module.exports = __webpack_public_path__ + "static/monzo-hugo-8d96bf16eeb6b48989934c129a9720c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/avatars/monzo-hugo.png
// module id = 2507
// module chunks = 63239383231690